import React from "react";
import { useEffect, useRef, useState, useContext } from "react";
import PropTypes from "prop-types";
import Button from "../../components/button";
import Impact from "../../components/impact";

const JobOpeningContainer = ({ mainData, classOption = "" }) => {
    return (
        <div className={`funfact-section position-relative ${classOption}`}>
            <div className="my-10 y-background-color">
                <div className="col-xl-12 col-lg-12 mx-auto text-center pt-1">
                    <div className=" title-section text-center p-5">
                        <p className="font-weight-bold g-color">
                            <b>
                                We are committed to transparency not just with
                                our customers, but also with our prospective
                                employees. <br />
                                It is our aim to ensure that everyone is given
                                an equal opportunity to prove their self.
                            </b>
                        </p>
                    </div>
                </div>
            </div>
            <div className="container mb-10">
                <div className="row mb-5 ">
                    <div className="col-xl-12 col-lg-12 mx-auto text-center">
                        <div className=" title-section text-center mb-5">
                            <h4 className="title pb-4">
                                <span>
                                    <i>Join us and build </i>
                                </span>
                                <span className="g-color ">
                                    <i>your story with us!</i>
                                </span>
                            </h4>
                            <p className="pb-4 ">
                                At NeoGrowth, you will have the opportunity to
                                own your success story. Are you ready for a
                                rewarding and satisfying career journey with us?
                            </p>
                            <h4 className="">
                                <span>Open Positions</span>
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center mb-5">
                    <div
                        className={
                            "b-background-color align-content-center radius-box p-2 m-2 d-flex"
                        }
                    >
                        <div className="col-lg-4 col-sm-4 align-content-center mx-3">
                            <h5 className="">
                                <b>Position</b>
                            </h5>
                        </div>
                        <div className="col-lg-3 col-sm-4 align-content-center me-3">
                            <h5 className="">
                                <b>Department</b>
                            </h5>
                        </div>
                        <div className="col-lg-3 col-sm-4 align-content-center me-3">
                            <h5 className="">
                                <b>Location</b>
                            </h5>
                        </div>
                        <div className="col-lg-2 col-sm-4 align-content-center ">
                            <h5 className="">{/* <b>Action</b> */}</h5>
                        </div>
                    </div>
                    {mainData[0].search &&
                        mainData[0].search.map((single, key) => {
                            return (
                                <a
                                    key={key}
                                    className={
                                        single.classOption +
                                        " align-content-center radius-box p-2 m-2 d-flex"
                                    }
                                    href={"job-opening/" + single.path}
                                >
                                    <div className="col-lg-4 col-sm-4 align-content-center mx-3">
                                        <p className="b-color">
                                            {single.title}
                                        </p>
                                    </div>
                                    <div className="col-lg-3 col-sm-4 align-content-center me-3">
                                        <p className="d-color">
                                            {single.department}
                                        </p>
                                    </div>
                                    <div
                                        className="col-lg-3 col-sm-4 align-content-center me-3"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title={single.location}
                                    >
                                        <p className="d-color">
                                            {single.miniLocation}
                                        </p>
                                    </div>
                                    <div className="col-lg-2 col-sm-4 align-content-center ">
                                        <Button
                                            classOption="btn btn-sm btn-primary btn-hover-primary"
                                            text="Apply"
                                            path={"job-opening/" + single.path}
                                        />
                                    </div>
                                </a>
                            );
                        })}
                </div>
            </div>
            {/* <div className="py-5 my-5 g-background-color">
                <div className="col-xl-12 col-lg-12 mx-auto text-center ">
                    <div className="title-section title-section text-center">
                        <h3 className="title pb-4">
                            <span>
                                <i>Life at </i>
                            </span>
                            <span className="g-color ">
                                <i>NeoGrowth</i>
                            </span>
                        </h3>
                        <p className="pb-4 d-color">
                            We believe that happy and healthy employees make the
                            happy and healthy workplace. Our offerings to
                            employees go beyond the monetary benefits.
                        </p>
                        <Button
                            classOption="btn btn-sm btn-primary btn-hover-primary"
                            text="Know more"
                            path={"careers"}
                        />
                    </div>
                </div>
            </div> */}
        </div>
    );
};

JobOpeningContainer.propTypes = {
    classOption: PropTypes.string,
    mainData: PropTypes.array,
};

export default JobOpeningContainer;
